import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  deepSpread,
  mergeDocuments,
  mergeWebsocketDocuments,
  removeDocumentById,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import type { TaskGroup } from './task-group.model';
import { transformTaskGroup } from './task-group.transformers';
import type { TaskGroupCollection } from './task-group.types';

export function taskGroupReducer(
  state: CollectionStateSlice<TaskGroupCollection> = {},
  action: CollectionActions<TaskGroupCollection>,
): CollectionStateSlice<TaskGroupCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'taskGroup') {
        const { result, ref, order } = action.payload;

        return mergeDocuments<TaskGroupCollection>(
          state,
          transformIntoDocuments(
            result.task_groups,
            transformTaskGroup,
            ref.path.authUid,
          ),
          order,
          ref,
        );
      }
      return state;
    }

    case 'API_PUSH_SUCCESS': {
      if (action.payload.type === 'taskGroup') {
        const { result, ref } = action.payload;
        return mergeWebsocketDocuments<TaskGroupCollection>(
          state,
          transformIntoDocuments(
            [result.task_group],
            transformTaskGroup,
            ref.path.authUid,
          ),
          ref,
        );
      }
      return state;
    }

    case 'API_DELETE_SUCCESS': {
      if (action.payload.type === 'taskGroup') {
        const { ref, originalDocument } = action.payload;
        return removeDocumentById<TaskGroupCollection>(
          ref,
          state,
          originalDocument.id,
        );
      }
      return state;
    }

    case 'API_UPDATE': {
      if (action.payload.type === 'taskGroup') {
        const { delta, ref, originalDocument } = action.payload;

        return mergeWebsocketDocuments<TaskGroupCollection>(
          state,
          transformIntoDocuments(
            [deepSpread(originalDocument, delta)],
            (t: TaskGroup) => t,
          ),
          ref,
        );
      }
      return state;
    }

    case 'API_UPDATE_SUCCESS': {
      if (action.payload.type === 'taskGroup') {
        const { result, ref } = action.payload;

        return mergeWebsocketDocuments<TaskGroupCollection>(
          state,
          transformIntoDocuments(
            [result.task_group],
            transformTaskGroup,
            ref.path.authUid,
          ),
          ref,
        );
      }
      return state;
    }

    default:
      return state;
  }
}
